export default {
  list: {
    data: null,
    loading: false,
    error: null
  }
}
